import React from "react";
import get from "lodash/get";
import clone from "lodash/clone";

import {
  TextField,
  Checkbox,
  RaisedButton,
  SelectField,
  MenuItem
} from "material-ui";
import ColorPicker from "rc-color-picker";
import Codemirror from "react-codemirror";
import "codemirror/mode/htmlmixed/htmlmixed";

import QuillEditor from "../quill-editor.jsx";
import ConfiguratorInjectedSelect from "./configurator-injected-select.jsx";
import ImageDropzone from "../image-dropzone.jsx";
import CurrencyField from "../currency-field.jsx";
import QuantityEditor from "../quantity-editor.jsx";
import InfoNotice from "../info-notice.jsx";

// This is janky...
import PassBucketStore from "../../../stores/PassBucketStore";

class ConfiguratorItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      htmlRawMode: false,
      forcePreviewMode: false,
      isFocused: false
    };
  }

  getStyles() {
    return {
      wrapper: {
        margin: "20px 0"
      },
      thinWraper: {
        // when lacking a name
        margin: 0
      },
      thinnestWrapper: {
        // when lacking a description too
        marginTop: -10,
        marginBottom: 20
      },
      subheader: {
        marginBottom: 20
      },
      label: {
        fontWeight: "bold"
      },
      subitemLabel: {
        fontSize: 12
      },
      mapLabel: {
        fontSize: 14,
        marginTop: 15,
        marginBottom: -10,
        fontWeight: "bold",
        textTransform: "uppercase"
      },
      description: {
        fontSize: 12,
        marginBottom: 5
      },
      insertables: {
        fontSize: 12
      },
      insertable: {
        textDecoration: "underline",
        cursor: "pointer",
        margin: "0 2px"
      },
      checkboxLabel: {
        marginLeft: -10,
        fontSize: 12
      },
      editorSwitcher: {
        textDecoration: "underline",
        fontSize: 12,
        cursor: "pointer"
      },
      forcePreviewLink: {
        textDecoration: "underline",
        cursor: "pointer",
        marginBottom: 10
      },
      arrayAddableLink: {
        textDecoration: "underline",
        cursor: "pointer"
      },
      arrayAddableAddAnother: {
        marginTop: 10
      },
      deleteImageLink: {
        display: "block",
        textDecoration: "underline",
        cursor: "pointer"
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      {
        item,
        config,
        eventBucket,
        isSubitem,
        subitemParent,
        subitemDefault,
        subitemMappedFromValue,
        isGod,
        isEnterprise
      } = this.props,
      value = get(
        config,
        isSubitem ? `${subitemParent}.${item.key}` : item.key
      );

    if (item.god_only && !isGod) {
      return null;
    }

    if (item.enterprise_only && !isEnterprise) {
      return null;
    }

    if (item.show_only_if) {
      let showOnlyIfOkay = Object.keys(item.show_only_if).every(key => {
        if (key && key[0] === "#") {
          // event bucket value (format: `#.xxx`)
          return get(eventBucket, key.substring(2)) === item.show_only_if[key];
        }

        let injectedKey = key.replace(/^\@/, subitemParent); // local reference
        let val = get(config, injectedKey);
        return (
          item.show_only_if[key] === val ||
          (item.show_only_if[key] === "$$any$$" && !!val)
        );
      });
      if (!showOnlyIfOkay) {
        return null;
      }
    }

    // Default inject from pass bucket for subsection
    if (
      !value &&
      isSubitem &&
      item.default_inject &&
      item.default_inject.objects === "pass_buckets"
    ) {
      let fixedCode = (subitemMappedFromValue || "").replace(/--.+$/, "");
      let injectFrom = PassBucketStore.getPassBucketsForEventBucket(
        eventBucket.id
      ).find(b => b.code === fixedCode);
      if (injectFrom) {
        value = get(injectFrom, item.default_inject.inject);
      }
      if (!value) {
        return <div />;
      } // wait for value to load before rendering
    }

    // Inject defaults if no value
    if (!value && subitemDefault) {
      value = subitemDefault[item.key];
    }

    let component = <div></div>;

    if (item.type === "subheader") {
      return (
        <div style={styles.subheader}>
          <div style={Object.assign(styles.label)}>{item.name}</div>
          <div style={styles.description}>{item.description}</div>
        </div>
      );

      // STRING
    } else if (item.type === "string") {
      component = (
        <div>
          <TextField
            name={item.key}
            /* workaround for https://github.com/callemall/material-ui/issues/4430#issuecomment-239175166 */
            defaultValue={value ? value : undefined}
            ref={r => {
              this.textField = r;
            }}
            style={{ marginTop: -15 }}
            fullWidth={true}
            multiLine={!item.oneline}
            placeholder={item.placeholder}
            onFocus={() => {
              this.setState({ isFocused: true });
            }}
            onBlur={() => {
              this.setState({ isFocused: false });
            }}
            onChange={e => {
              e.stopPropagation(); // https://github.com/callemall/material-ui/issues/2189
              this.props.onConfigChange(item.key, e.target.value);
            }}
          />
          {item.insertables && item.insertables.length ? (
            <div style={styles.insertables}>
              Insert:
              {item.insertables.map(insertable => (
                <span
                  key={insertable.label}
                  style={styles.insertable}
                  onTouchTap={() => {
                    let content = value + insertable.value;
                    if (this.textField) {
                      this.textField.getInputNode().value = content;
                      this.textField.focus();
                    } else {
                      this.props.onConfigChange(item.key, content);
                    }
                  }}
                >
                  {insertable.label}
                </span>
              ))}
            </div>
          ) : null}
        </div>
      );

      // COLOR
    } else if (item.type === "color") {
      component = (
        <div>
          <ColorPicker
            animation="slide-up"
            color={value}
            alpha={100}
            onChange={colors => {
              this.props.onConfigChange(item.key, colors.color);
            }}
          />
        </div>
      );

      // DROPDOWN
    } else if (item.type === "dropdown") {
      component = (
        <div>
          <SelectField
            value={value || ""}
            onChange={(e, i, value) => {
              e.stopPropagation(); // https://github.com/callemall/material-ui/issues/2189
              this.props.onConfigChange(item.key, value);
            }}
          >
            {item.options.map(o => {
              return <MenuItem value={o.value} primaryText={o.label} />;
            })}
          </SelectField>
        </div>
      );

      // BOOLEAN
    } else if (item.type === "boolean") {
      component = (
        <div>
          <Checkbox
            checked={value}
            label={item.checkbox_label}
            labelStyle={styles.checkboxLabel}
            onCheck={(e, isChecked) => {
              e.stopPropagation(); // https://github.com/callemall/material-ui/issues/2189
              this.props.onConfigChange(item.key, !value);
            }}
          />
        </div>
      );

      // IMAGE
    } else if (item.type === "image") {
      component = (
        <div>
          {value ? (
            <img
              src={value}
              style={{
                maxHeight: 150,
                maxWidth: "100%",
                backgroundColor: "hsla(31,15%,50%,.1)"
              }}
            />
          ) : null}
          <ImageDropzone
            crop={item.crop}
            style={{
              height: "auto",
              fontSize: "0.75em",
              lineHeight: "1.25",
              padding: 10,
              border: "1px dashed #ccc",
              cursor: "pointer"
            }}
            onDrop={files => {
              this.props.onConfigChange(item.key, files[0], { file: true });
            }}
          >
            <div>
              Drop an image here, or click to select.
              {value ? (
                <a
                  style={styles.deleteImageLink}
                  onTouchTap={() => {
                    this.props.onConfigChange(item.key, "");
                  }}
                >
                  [Delete current image]
                </a>
              ) : null}
            </div>
          </ImageDropzone>
        </div>
      );

      // HTML
    } else if (item.type === "html") {
      component = (
        <QuillEditor
          value={value}
          inlineBasicOnly={item.inline_basic_only}
          bounds=".EventBucketConfigurator--container"
          onChange={content => {
            this.props.onConfigChange(item.key, content);
          }}
          sanitizeEmpty
        />
      );

      if (item.allow_raw_editor || item.force_raw_editor) {
        let { htmlRawMode } = this.state,
          rawEditor = (
            <div>
              <style>{`
                .CodeMirror {
                  border: 1px solid #ccc;
                  height: 150px;
                }
              `}</style>
              <Codemirror
                value={value}
                onChange={content => {
                  this.props.onConfigChange(item.key, content);
                }}
                options={{
                  lineWrapping: true,
                  lineNumbers: true,
                  mode: { name: "htmlmixed" }
                }}
              />
            </div>
          );

        if (value && value.indexOf("eventive:allow-unsafe-embed") !== -1) {
          htmlRawMode = true;
        }

        component = (
          <div>
            {!item.force_raw_editor ? (
              <span
                style={styles.editorSwitcher}
                onTouchTap={() => this.setState({ htmlRawMode: !htmlRawMode })}
              >
                Switch to {htmlRawMode ? "visual" : "raw"} editor
              </span>
            ) : null}
            {item.force_raw_editor || htmlRawMode ? rawEditor : component}
          </div>
        );
      }

      // CURRENCY
    } else if (item.type === "currency") {
      component = (
        <CurrencyField
          name={item.key}
          value={value}
          placeholder="$0.00"
          style={{ marginTop: -15 }}
          onFocus={() => {
            this.setState({ isFocused: true });
          }}
          onBlur={() => {
            this.setState({ isFocused: false });
          }}
          onChange={e => {
            this.props.onConfigChange(item.key, e.target.value);
          }}
        />
      );

      // QUANTITY
    } else if (item.type === "quantity") {
      component = (
        <QuantityEditor
          name={item.key}
          quantity={value}
          min={item.min}
          max={item.max}
          style={{ marginTop: -10, marginLeft: -15 }}
          onFocus={() => {
            this.setState({ isFocused: true });
          }}
          onBlur={() => {
            this.setState({ isFocused: false });
          }}
          updateQuantity={q => {
            this.props.onConfigChange(item.key, q);
          }}
        />
      );

      // INJECTED
    } else if (item.inject) {
      component = (
        <ConfiguratorInjectedSelect
          inject={item.inject}
          eventBucket={eventBucket}
          type={item.type}
          repeatable={item.repeatable}
          repeatableKey={
            item.repeatable &&
            subitemParent &&
            subitemParent.replace(/[^0-9]/g, "")
          }
          value={value}
          onChange={selected => {
            this.props.onConfigChange(item.key, selected);
          }}
        />
      );

      // MAP
      // This mean that the items takes another config item that is an array and for each item in the array,
      // generates a new set of items. Basically used to configure "each one" of a particular item.
    } else if (item.map || item.type === "array_addable") {
      let arrayToMap,
        isArrayAddable = item.type === "array_addable";

      if (item.map) {
        if (item.map.indexOf(".") !== -1) {
          if (Array.isArray(get(config, item.map))) {
            arrayToMap = get(config, item.map);
          } else {
            // Assume it is nested, then, and capture all the nested fields.
            let [container, subfield] = item.map.split(".");
            arrayToMap = [].concat.apply(
              [],
              (config[container] || []).map(c => c[subfield])
            );
          }
        } else {
          arrayToMap = config[item.map] || [];
        }
      } else {
        arrayToMap = value || [];
      }

      let subitemDefault = get(config, `${item.key}--default`);

      component = (
        <div>
          {arrayToMap.map((otherItemValue, i) => {
            let labelContents;

            if (isArrayAddable) {
              labelContents = (
                <span>
                  {item.type_label || "item"} #{i + 1} (
                  <a
                    style={styles.arrayAddableLink}
                    onTouchTap={() => {
                      let modified = clone(value);
                      modified.splice(i, 1);
                      this.props.onConfigChange(item.key, modified);
                    }}
                  >
                    Delete {item.type_label || "item"}
                  </a>
                  )
                </span>
              );
            } else {
              labelContents = otherItemValue;
            }

            const triggerFocus = () => {
              this.props.onConfigFocus(item.key, item, otherItemValue || {});
            };
            const triggerBlur = () => {
              !this.state.isFocused && this.props.onConfigBlur(item.key, item);
            };

            return (
              <div onMouseEnter={triggerFocus} onMouseLeave={triggerFocus}>
                <div style={styles.mapLabel}>{labelContents}</div>
                {item.items.map(subitem => {
                  return (
                    <ConfiguratorItem
                      item={subitem}
                      config={config}
                      eventBucket={eventBucket}
                      isSubitem={true}
                      subitemParent={`${
                        this.props.subitemParent
                          ? `${this.props.subitemParent}.`
                          : ""
                      }${
                        isArrayAddable
                          ? `${item.key}[${i}]`
                          : `${item.key}.${otherItemValue}`
                      }`}
                      subitemMappedFromValue={otherItemValue}
                      subitemDefault={subitemDefault}
                      onConfigFocus={this.props.onConfigFocus}
                      onConfigBlur={this.props.onConfigBlur}
                      onConfigChange={(key, value) => {
                        this.props.onConfigChange(
                          isArrayAddable
                            ? `${item.key}[${i}].${key}`
                            : `${item.key}.${otherItemValue}.${key}`,
                          value
                        );
                        if (subitem.trigger_preview_on_change) {
                          triggerFocus();
                        }
                      }}
                    />
                  );
                })}
              </div>
            );
          })}
          {isArrayAddable ? (
            <RaisedButton
              style={styles.arrayAddableAddAnother}
              label={`Add another ${item.type_label || "item"}`}
              onTouchTap={() => {
                let modified = clone(value) || [],
                  defaultValue = get(config, `${item.key}--default`);
                modified.push(defaultValue ? clone(defaultValue) : {});
                this.props.onConfigChange(item.key, modified);
              }}
            />
          ) : null}
        </div>
      );
    }

    let forcePreviewLink = null;
    if (item.force_preview) {
      let { forcePreviewMode } = this.state;

      forcePreviewLink = (
        <div
          style={styles.forcePreviewLink}
          title="Temporarily make the site appear in a mode in which this setting would apply."
          onTouchTap={() => {
            if (!forcePreviewMode) {
              this.setState({ forcePreviewMode: true });
              this.props.onForcePreview(item.force_preview, item);
            } else {
              this.setState({ forcePreviewMode: false });
              this.props.onEndForcePreview(item.force_preview, item);
            }
          }}
        >
          ({forcePreviewMode ? "stop previewing" : "preview"} on site)
        </div>
      );
    }

    let infoNotice = null;
    if (item.info_notice) {
      infoNotice = (
        <InfoNotice style={{ marginTop: 0, marginBottom: 5 }}>
          <span dangerouslySetInnerHTML={{ __html: item.info_notice }} />
        </InfoNotice>
      );
    }

    return (
      <div
        style={
          item.name
            ? styles.wrapper
            : item.description
              ? styles.thinWraper
              : styles.thinnestWrapper
        }
        onMouseEnter={() => {
          this.props.onConfigFocus(item.key, item);
        }}
        onMouseLeave={() => {
          !this.state.isFocused && this.props.onConfigBlur(item.key, item);
        }}
      >
        <div
          style={Object.assign(styles.label, isSubitem && styles.subitemLabel)}
        >
          {item.name}
        </div>
        <div style={styles.description}>
          {item.description}
          {forcePreviewLink}
          {infoNotice}
        </div>
        {component}
      </div>
    );
  }
}

export default ConfiguratorItem;



// WEBPACK FOOTER //
// ./src/app/components/partials/configurator/configurator-item.jsx